/*
import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";

import App from "./App.vue";
import IframePayment from "@/components/IframePayment.vue";
import IframeRecurring from "@/components/IframeRecurring.vue";
import IframeNewCard from "@/components/IframeNewCard.vue";
import IframeNewACH from "@/components/IframeNewACH.vue";
import IframeRecurringACH from "./components/IframeRecurringACH.vue";
import MerchantWareIframePayment from "./components/MerchantWareIframePayment.vue";

const routes = [
  {
    path: "/fe/payment-link/:pvId/:orderId",
    name: "Payment",
    component: IframePayment,
    props: (route) => {
      return {
        ...route.params,
        ...{ pvId: Number.parseInt(route.params.pvId, 10) || undefined },
      };
    },
  },
  {
    path: "/fe/recurring-link/:pvId/:customerId",
    name: "Recurring Payment",
    component: IframeRecurring,
    props: (route) => {
      return {
        ...route.params,
        ...{ pvId: Number.parseInt(route.params.pvId, 10) || undefined },
      };
    },
  },
  {
    path: "/fe/recurring-link-ach/:pvId/:customerId",
    name: "Recurring ACH Payment",
    component: IframeRecurringACH,
    props: (route) => {
      return {
        ...route.params,
        ...{ pvId: Number.parseInt(route.params.pvId, 10) || undefined },
      };
    },
  },
  {
    path: "/fe/new-card/:customerId/:addressId",
    name: "Add New Card",
    component: IframeNewCard,
    props: true,
  },
  {
    path: "/fe/new-ach/:customerId/:addressId",
    name: "Add New Bank Account",
    component: IframeNewACH,
    props: true,
  },
  {
    path: "/mw/payment-link/:pvId/:orderId",
    name: "Payment link with MerchantWare",
    component: MerchantWareIframePayment,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const app = createApp(App);

app.use(router);
app.mount("#app");
*/

import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";

import App from "./App.vue";

const routes = [
  {
    path: "/fe/payment-link/:pvId/:orderId",
    name: "Payment",
    component: () => import("@/components/IframePayment.vue"),
    props: (route) => {
      return {
        ...route.params,
        pvId: Number.parseInt(route.params.pvId, 10) || undefined,
      };
    },
  },
  {
    path: "/fe/recurring-link/:pvId/:customerId",
    name: "Recurring Payment",
    component: () => import("@/components/IframeRecurring.vue"),
    props: (route) => {
      return {
        ...route.params,
        pvId: Number.parseInt(route.params.pvId, 10) || undefined,
      };
    },
  },
  {
    path: "/fe/recurring-link-ach/:pvId/:customerId",
    name: "Recurring ACH Payment",
    component: () => import("./components/IframeRecurringACH.vue"),
    props: (route) => {
      return {
        ...route.params,
        pvId: Number.parseInt(route.params.pvId, 10) || undefined,
      };
    },
  },
  {
    path: "/fe/new-card/:customerId/:addressId",
    name: "Add New Card",
    component: () => import("@/components/IframeNewCard.vue"),
    props: true,
  },
  {
    path: "/fe/new-ach/:customerId/:addressId",
    name: "Add New Bank Account",
    component: () => import("@/components/IframeNewACH.vue"),
    props: true,
  },
  {
    path: "/fe/mw-payment-link/:pvId/:orderId",
    name: "Payment link with MerchantWare",
    component: () => import("./components/MerchantWareIframePaymentv2.vue"),
    props: true,
  },
  {
    path: "/fe/mw-new-card/:customerId/:addressId",
    name: "Add Global MerchantWare New Card",
    component: () => import("@/components/MerchantWareIframeNewCard.vue"),
    props: true,
  },
  {
    path: "/fe/mw-recurring-link/:pvId/:customerId",
    name: "Global MerchantWare Recurring Payment",
    component: () => import("@/components/MerchantWareIframeRecurring.vue"),
    props: (route) => {
      return {
        ...route.params,
        pvId: Number.parseInt(route.params.pvId, 10) || undefined,
      };
    },
  },
  {
    path: "/fe/mw-recurring-link-ach/:pvId/:customerId",
    name: "Global MerchantWare Recurring ACH Payment",
    component: () => import("./components/MerchantWareIframeRecurringACH.vue"),
    props: (route) => {
      return {
        ...route.params,
        pvId: Number.parseInt(route.params.pvId, 10) || undefined,
      };
    },
  },
  {
    path: "/fe/mw-token-card",
    name: "Add Global MerchantWare Card Token",
    component: () => import("@/components/MerchantWareIframeCardToken.vue"),
    props: true,
  },
  {
    path: "/fe/mw-token-ach",
    name: "Add Global MerchantWare ACH Token",
    component: () => import("@/components/MerchantWareIframeACHToken.vue"),
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const app = createApp(App);

app.use(router);
app.mount("#app");
